import React from 'react'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import { TextArea } from '@/components/uikit'
import { theme } from '@/theme'

import { Toggle } from '../Toggle'

import type { Path } from 'react-hook-form'

export const ToggleTitle = styled.span`
  font-family: ${theme.fonts.mainFont};
  font-style: normal;
  font-weight: ${theme.fontWeight.medium};
  font-size: 16px;
`

export const FieldsWrapper = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  background-color: ${({ $disabled }) =>
    $disabled ? 'transparent' : theme.colors.white};
  border: ${({ $disabled }) =>
    $disabled ? `1px solid ${theme.colors.crystalBay}` : 'none'};
`

export const PadlessToggle = styled(Toggle)`
  padding: 0;
  background: none;
  border: none;
`

type ToggleAndDescriptionProps = React.PropsWithChildren<{
  toggleFormField: Path<any>
  textAreaFormField?: Path<any>
  toggleLabel: React.ReactNode
  textAreaPlaceholder?: string
}>

export const ToggleAndDescription = ({
  toggleFormField,
  textAreaFormField,
  toggleLabel,
  textAreaPlaceholder,
  children,
}: ToggleAndDescriptionProps) => {
  const { register, watch } = useFormContext<any>()
  const shouldShowChildren = !!toggleFormField && watch(toggleFormField)
  const shouldShowTextArea = !!textAreaFormField && shouldShowChildren
  return (
    <FieldsWrapper>
      <PadlessToggle
        {...register(toggleFormField)}
        label={<ToggleTitle>{toggleLabel}</ToggleTitle>}
      />
      {shouldShowTextArea && (
        <TextArea
          {...register(textAreaFormField)}
          placeholder={textAreaPlaceholder}
        />
      )}
      {shouldShowChildren && children}
    </FieldsWrapper>
  )
}
